export const appHead = {"meta":[{"charset":"utf-8"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"viewport","content":"width=device-width, initial-scale=1.0"},{"name":"author","content":"한국인사관리협회"},{"name":"publisher","content":"한국인사관리협회"},{"name":"description","content":"한국인사관리협회는 인사제도, 노무관리, HR 전문가 교육과 인증을 제공하는 국내 대표 인사교육기관입니다."},{"name":"keywords","content":"한국인사관리협회, 인사뱅크, HR교육, 인사제도, 인사관리자격증, 노무교육, 조직관리"},{"name":"format-detection","content":"telephone=no"},{"name":"naver-site-verification","content":"24e886358d97fb69bc24161a604e3dbc4ec8af22"},{"name":"google-site-verification","content":"FnFtu7HX4kIz8UvJfB7cGhhrLn3zzyjAeiz3_eQr_yY"},{"property":"og:type","content":"website"},{"property":"og:title","content":"한국인사관리협회 - 공식 홈페이지"},{"property":"og:description","content":"HR 전문가를 위한 인사·노무 관리 교육과 인증 제공"},{"property":"og:url","content":"https://insabank.com"},{"property":"og:site_name","content":"한국인사관리협회"},{"property":"og:image","content":"https://insabank.com/og-image.png"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"canonical","href":"https://insabank.com"}],"style":[],"script":[{"src":"https://dapi.kakao.com/v2/maps/sdk.js?appkey=b44a73d0e3d47996703d7dd1396606b8&autoload=false","defer":true},{"src":"https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js","defer":true}],"noscript":[],"title":"한국인사관리협회","htmlAttrs":{"lang":"ko"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false